import { Component as n, createElement as t, options as e, toChildArray as r, Fragment as u, render as o, hydrate as i, createContext as l, createRef as c, cloneElement as f } from "preact";
export { Component, Fragment, createContext, createElement, createRef } from "preact";
import { useState as a, useId as s, useReducer as h, useEffect as v, useLayoutEffect as d, useRef as p, useImperativeHandle as m, useMemo as y, useCallback as _, useContext as b, useDebugValue as S } from "preact/hooks";
export * from "preact/hooks";

function g(n, t) {
  for (var e in t) {
    n[e] = t[e];
  }

  return n;
}

function C(n, t) {
  for (var e in n) {
    if ("__source" !== e && !(e in t)) return !0;
  }

  for (var r in t) {
    if ("__source" !== r && n[r] !== t[r]) return !0;
  }

  return !1;
}

function E(n) {
  this.props = n;
}

function w(n, e) {
  function r(n) {
    var t = this.props.ref,
        r = t == n.ref;
    return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : C(this.props, n);
  }

  function u(e) {
    return this.shouldComponentUpdate = r, t(n, e);
  }

  return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}

(E.prototype = new n()).isPureReactComponent = !0, E.prototype.shouldComponentUpdate = function (n, t) {
  return C(this.props, n) || C(this.state, t);
};
var R = e.__b;

e.__b = function (n) {
  n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), R && R(n);
};

var x = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;

function N(n) {
  function t(t) {
    var e = g({}, t);
    return delete e.ref, n(e, t.ref || null);
  }

  return t.$$typeof = x, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}

var k = function k(n, t) {
  return null == n ? null : r(r(n).map(t));
},
    A = {
  map: k,
  forEach: k,
  count: function count(n) {
    return n ? r(n).length : 0;
  },
  only: function only(n) {
    var t = r(n);
    if (1 !== t.length) throw "Children.only";
    return t[0];
  },
  toArray: r
},
    O = e.__e;

e.__e = function (n, t, e, r) {
  if (n.then) for (var u, o = t; o = o.__;) {
    if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
  }
  O(n, t, e, r);
};

var T = e.unmount;

function I(n, t, e) {
  return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function (n) {
    "function" == typeof n.__c && n.__c();
  }), n.__c.__H = null), null != (n = g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function (n) {
    return I(n, t, e);
  })), n;
}

function L(n, t, e) {
  return n && (n.__v = null, n.__k = n.__k && n.__k.map(function (n) {
    return L(n, t, e);
  }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
}

function U() {
  this.__u = 0, this.t = null, this.__b = null;
}

function D(n) {
  var t = n.__.__c;
  return t && t.__a && t.__a(n);
}

function F(n) {
  var e, r, u;

  function o(o) {
    if (e || (e = n()).then(function (n) {
      r = n.default || n;
    }, function (n) {
      u = n;
    }), u) throw u;
    if (!r) throw e;
    return t(r, o);
  }

  return o.displayName = "Lazy", o.__f = !0, o;
}

function M() {
  this.u = null, this.o = null;
}

e.unmount = function (n) {
  var t = n.__c;
  t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), T && T(n);
}, (U.prototype = new n()).__c = function (n, t) {
  var e = t.__c,
      r = this;
  null == r.t && (r.t = []), r.t.push(e);

  var u = D(r.__v),
      o = !1,
      i = function i() {
    o || (o = !0, e.__R = null, u ? u(l) : l());
  };

  e.__R = i;

  var l = function l() {
    if (! --r.__u) {
      if (r.state.__a) {
        var n = r.state.__a;
        r.__v.__k[0] = L(n, n.__c.__P, n.__c.__O);
      }

      var t;

      for (r.setState({
        __a: r.__b = null
      }); t = r.t.pop();) {
        t.forceUpdate();
      }
    }
  },
      c = !0 === t.__h;

  r.__u++ || c || r.setState({
    __a: r.__b = r.__v.__k[0]
  }), n.then(i, i);
}, U.prototype.componentWillUnmount = function () {
  this.t = [];
}, U.prototype.render = function (n, e) {
  if (this.__b) {
    if (this.__v.__k) {
      var r = document.createElement("div"),
          o = this.__v.__k[0].__c;
      this.__v.__k[0] = I(this.__b, r, o.__O = o.__P);
    }

    this.__b = null;
  }

  var i = e.__a && t(u, null, n.fallback);
  return i && (i.__h = null), [t(u, null, e.__a ? null : n.children), i];
};

var V = function V(n, t, e) {
  if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for (e = n.u; e;) {
    for (; e.length > 3;) {
      e.pop()();
    }

    if (e[1] < e[0]) break;
    n.u = e = e[2];
  }
};

function W(n) {
  return this.getChildContext = function () {
    return n.context;
  }, n.children;
}

function P(n) {
  var e = this,
      r = n.i;
  e.componentWillUnmount = function () {
    o(null, e.l), e.l = null, e.i = null;
  }, e.i && e.i !== r && e.componentWillUnmount(), n.__v ? (e.l || (e.i = r, e.l = {
    nodeType: 1,
    parentNode: r,
    childNodes: [],
    appendChild: function appendChild(n) {
      this.childNodes.push(n), e.i.appendChild(n);
    },
    insertBefore: function insertBefore(n, t) {
      this.childNodes.push(n), e.i.appendChild(n);
    },
    removeChild: function removeChild(n) {
      this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
    }
  }), o(t(W, {
    context: e.context
  }, n.__v), e.l)) : e.l && e.componentWillUnmount();
}

function $(n, e) {
  var r = t(P, {
    __v: n,
    i: e
  });
  return r.containerInfo = e, r;
}

(M.prototype = new n()).__a = function (n) {
  var t = this,
      e = D(t.__v),
      r = t.o.get(n);
  return r[0]++, function (u) {
    var o = function o() {
      t.props.revealOrder ? (r.push(u), V(t, n, r)) : u();
    };

    e ? e(o) : o();
  };
}, M.prototype.render = function (n) {
  this.u = null, this.o = new Map();
  var t = r(n.children);
  n.revealOrder && "b" === n.revealOrder[0] && t.reverse();

  for (var e = t.length; e--;) {
    this.o.set(t[e], this.u = [1, 0, this.u]);
  }

  return n.children;
}, M.prototype.componentDidUpdate = M.prototype.componentDidMount = function () {
  var n = this;
  this.o.forEach(function (t, e) {
    V(n, e, t);
  });
};

var j = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103,
    z = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/,
    B = "undefined" != typeof document,
    H = function H(n) {
  return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};

function Z(n, t, e) {
  return null == t.__k && (t.textContent = ""), o(n, t), "function" == typeof e && e(), n ? n.__c : null;
}

function Y(n, t, e) {
  return i(n, t), "function" == typeof e && e(), n ? n.__c : null;
}

n.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function (t) {
  Object.defineProperty(n.prototype, t, {
    configurable: !0,
    get: function get() {
      return this["UNSAFE_" + t];
    },
    set: function set(n) {
      Object.defineProperty(this, t, {
        configurable: !0,
        writable: !0,
        value: n
      });
    }
  });
});
var q = e.event;

function G() {}

function J() {
  return this.cancelBubble;
}

function K() {
  return this.defaultPrevented;
}

e.event = function (n) {
  return q && (n = q(n)), n.persist = G, n.isPropagationStopped = J, n.isDefaultPrevented = K, n.nativeEvent = n;
};

var Q,
    X = {
  configurable: !0,
  get: function get() {
    return this.class;
  }
},
    nn = e.vnode;

e.vnode = function (n) {
  var t = n.type,
      e = n.props,
      u = e;

  if ("string" == typeof t) {
    var o = -1 === t.indexOf("-");

    for (var i in u = {}, e) {
      var l = e[i];
      B && "children" === i && "noscript" === t || "value" === i && "defaultValue" in e && null == l || ("defaultValue" === i && "value" in e && null == e.value ? i = "value" : "download" === i && !0 === l ? l = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + t) && !H(e.type) ? i = "oninput" : /^onfocus$/i.test(i) ? i = "onfocusin" : /^onblur$/i.test(i) ? i = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(i) ? i = i.toLowerCase() : o && z.test(i) ? i = i.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : null === l && (l = void 0), /^oninput$/i.test(i) && (i = i.toLowerCase(), u[i] && (i = "oninputCapture")), u[i] = l);
    }

    "select" == t && u.multiple && Array.isArray(u.value) && (u.value = r(e.children).forEach(function (n) {
      n.props.selected = -1 != u.value.indexOf(n.props.value);
    })), "select" == t && null != u.defaultValue && (u.value = r(e.children).forEach(function (n) {
      n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
    })), n.props = u, e.class != e.className && (X.enumerable = "className" in e, null != e.className && (u.class = e.className), Object.defineProperty(u, "className", X));
  }

  n.$$typeof = j, nn && nn(n);
};

var tn = e.__r;

e.__r = function (n) {
  tn && tn(n), Q = n.__c;
};

var en = {
  ReactCurrentDispatcher: {
    current: {
      readContext: function readContext(n) {
        return Q.__n[n.__c].props.value;
      }
    }
  }
},
    rn = "17.0.2";

function un(n) {
  return t.bind(null, n);
}

function on(n) {
  return !!n && n.$$typeof === j;
}

function ln(n) {
  return on(n) ? f.apply(null, arguments) : n;
}

function cn(n) {
  return !!n.__k && (o(null, n), !0);
}

function fn(n) {
  return n && (n.base || 1 === n.nodeType && n) || null;
}

var an = function an(n, t) {
  return n(t);
},
    sn = function sn(n, t) {
  return n(t);
},
    hn = u;

function vn(n) {
  n();
}

function dn(n) {
  return n;
}

function pn() {
  return [!1, vn];
}

var mn = d;

function yn(n, t) {
  var e = t(),
      r = a({
    h: {
      __: e,
      v: t
    }
  }),
      u = r[0].h,
      o = r[1];
  return d(function () {
    u.__ = e, u.v = t, u.__ !== t() && o({
      h: u
    });
  }, [n, e, t]), v(function () {
    return u.__ !== u.v() && o({
      h: u
    }), n(function () {
      u.__ !== u.v() && o({
        h: u
      });
    });
  }, [n]), e;
}

var _n = {
  useState: a,
  useId: s,
  useReducer: h,
  useEffect: v,
  useLayoutEffect: d,
  useInsertionEffect: mn,
  useTransition: pn,
  useDeferredValue: dn,
  useSyncExternalStore: yn,
  startTransition: vn,
  useRef: p,
  useImperativeHandle: m,
  useMemo: y,
  useCallback: _,
  useContext: b,
  useDebugValue: S,
  version: "17.0.2",
  Children: A,
  render: Z,
  hydrate: Y,
  unmountComponentAtNode: cn,
  createPortal: $,
  createElement: t,
  createContext: l,
  createFactory: un,
  cloneElement: ln,
  createRef: c,
  Fragment: u,
  isValidElement: on,
  findDOMNode: fn,
  Component: n,
  PureComponent: E,
  memo: w,
  forwardRef: N,
  flushSync: sn,
  unstable_batchedUpdates: an,
  StrictMode: hn,
  Suspense: U,
  SuspenseList: M,
  lazy: F,
  __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: en
};
export { A as Children, E as PureComponent, hn as StrictMode, U as Suspense, M as SuspenseList, en as __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, ln as cloneElement, un as createFactory, $ as createPortal, _n as default, fn as findDOMNode, sn as flushSync, N as forwardRef, Y as hydrate, on as isValidElement, F as lazy, w as memo, Z as render, vn as startTransition, cn as unmountComponentAtNode, an as unstable_batchedUpdates, dn as useDeferredValue, mn as useInsertionEffect, yn as useSyncExternalStore, pn as useTransition, rn as version };